import axios from 'axios';
import notify from '../mixins/Notify';
import EventBus from '../modules/EventBus';
import { getCookie } from '../utils/WindowUtils';

export const HTTP_CREATED = 201;
export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_TIMEOUT = 408;
export const HTTP_INTERNAL_ERROR = 500;
export const HTTP_UNPROCESSABLE_ENTITY = 422;

axios.defaults.headers.common['X-BN-ONLINE-API-TOKEN'] = getCookie('BNONLINEAUTH');
axios.defaults.headers.common['X-BN-API-TOKEN'] = getCookie('BNETAUTH');
axios.defaults.headers.common['X-Api-Key'] = getCookie('BNETAUTH');

axios.interceptors.response.use((response) => {
    if (typeof response.data === 'string') {
        let data = response.data.replace(')]}\',', '');
        try {
            data = JSON.parse(data);
        } catch (e) {
            console.log('Not json');
        }
        response.data = data;
    }
    return response;
}, (error) => {
    if (error.response.status) {
        switch (error.response.status) {
        case HTTP_TIMEOUT:
            notify.failureNotify(
                'Időtúllépés történt a kommunikáció során',
                '#1003 Időtúllépés történt',
            );
            break;
        case HTTP_UNPROCESSABLE_ENTITY:
            // DO NOTHING HERE.
            break;
        case HTTP_FORBIDDEN:
        case HTTP_UNAUTHORIZED:
            notify.failureNotify(
                'Az Ön munkamenete lejárt, kérjük indítsa újra a tarifálást'
                + ' és ha szükséges jelentkezzen be újra',
                '#1006 Lejárt munkamenet',
            );
            break;
        case HTTP_INTERNAL_ERROR:
        case HTTP_BAD_REQUEST:
            notify.permanentNotify(
                error.response.data?.message && error.response.status === HTTP_BAD_REQUEST
                    ? error.response.data.message
                    : 'Váratlan hiba történt'
                    + ' a kérés feldolgozása közben. Ha a hiba továbbra is'
                    + ' fennáll kérjük értesítse ügyfélszolgálatunkat',
                `${error.response.status === HTTP_INTERNAL_ERROR ? '#1000' : '#1001'} Váratlan hiba történt`,
            );
            break;
        case HTTP_NOT_FOUND:
            notify.failureNotify(
                'Végpont nem található',
                '#1002 Végpont nem található',
            );
            break;
        default:
            notify.failureNotify(
                'Ismeretlen hiba történt a kommunikáció során',
                '#1005 Ismeretlen hiba történt',
            );
        }
    } else {
        notify.failureNotify(
            'Ismeretlen hiba történt a kommunikáció során',
            '#1004 Ismeretlen hiba történt',
        );
    }
    EventBus.$emit('abort');

    return Promise.reject(error);
});

axios.interceptors.request.use((config) => config, (error) => Promise.reject(error));
